export const REGISTER_ACCOUNT_REQUEST:"REGISTER_ACCOUNT_REQUEST"  = "REGISTER_ACCOUNT_REQUEST";
export const REGISTER_ACCOUNT_SUCCESS:"REGISTER_ACCOUNT_SUCCESS" = "REGISTER_ACCOUNT_SUCCESS";
export const REGISTER_ACCOUNT_FAILED:"REGISTER_ACCOUNT_FAILED" = "REGISTER_ACCOUNT_FAILED";

export const LOGIN_ACCOUNT_REQUEST:"LOGIN_ACCOUNT_REQUEST" = "LOGIN_ACCOUNT_REQUEST";
export const LOGIN_ACCOUNT_SUCCESS:"LOGIN_ACCOUNT_SUCCESS" = "LOGIN_ACCOUNT_SUCCESS";
export const LOGIN_ACCOUNT_FAILED:"LOGIN_ACCOUNT_FAILED" = "LOGIN_ACCOUNT_FAILED";

export const SAVE_REGISTER_ACCOUNT:"SAVE_REGISTER_ACCOUNT" = "SAVE_REGISTER_ACCOUNT";

export const FORGOT_PASSWORD_REQUEST:"FORGOT_PASSWORD_REQUEST" = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS:"FORGOT_PASSWORD_SUCCESS" = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILED:"FORGOT_PASSWORD_FAILED" = "FORGOT_PASSWORD_FAILED";

export const RESET_PASSWORD_REQUEST:"RESET_PASSWORD_REQUEST" = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS:"RESET_PASSWORD_SUCCESS" = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILED:"RESET_PASSWORD_FAILED" = "RESET_PASSWORD_FAILED";

export const GET_USER_REQUEST:"GET_USER_REQUEST" = "GET_USER_REQUEST";
export const GET_USER_SUCCESS:"GET_USER_SUCCESS" = "GET_USER_SUCCESS";
export const GET_USER_FAILED:"GET_USER_FAILED" = "GET_USER_FAILED";

export const UPDATE_USER_REQUEST:"UPDATE_USER_REQUEST" = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS:"UPDATE_USER_SUCCESS" = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILED:"UPDATE_USER_FAILED" = "UPDATE_USER_FAILED";

export const LOGOUT_ACCOUNT_REQUEST:"LOGOUT_ACCOUNT_REQUEST" = "LOGOUT_ACCOUNT_REQUEST";
export const LOGOUT_ACCOUNT_SUCCESS:"LOGOUT_ACCOUNT_SUCCESS" = "LOGOUT_ACCOUNT_SUCCESS";
export const LOGOUT_ACCOUNT_FAILED:"LOGOUT_ACCOUNT_FAILED" = "LOGOUT_ACCOUNT_FAILED";

export const UPDATE_TOKEN_REQUEST:"UPDATE_TOKEN_REQUEST" = "UPDATE_TOKEN_REQUEST";
export const UPDATE_TOKEN_SUCCESS:"UPDATE_TOKEN_SUCCESS" = "UPDATE_TOKEN_SUCCESS";
export const UPDATE_TOKEN_FAILED:"UPDATE_TOKEN_FAILED" = "UPDATE_TOKEN_FAILED";